import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@mui/styles'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import AddRoleModal from './addRole'
import isEqual from 'react-fast-compare'
import { addRole, updateRole, removeRole } from '../../Actions/Roles'
import ConfirmDialoag from '../common/ConfirmDialoag'
import { checkPrivileges } from '../../Helpers'
import {
  formDefault,
  privilegeCheckboxStyles as styles,
} from './constants'
import PrivilegesPanel from './PrivilegesPanel'

export { PrivilegesTree, PrivilagesTree } from './PrivilegesTree'
export { PrivilegeListRow, ListRow } from './PrivilegeListRow'
class roleModal extends Component {
  constructor () {
    super()
    this.state = {
      // all fields of form
      loader: false,
      addOption: false,
      editOption: false,
      showDetails: false,
      addO:false,
      selectedItem: '',
      isVisableRoleBtn: false,
      allPrivilagesGroups: '',
      onDeleteConfirmation: false,
      open: {},
      privilegeSearch: '',
      form: {...formDefault}
    }
    this.checkHandelChanges = this.checkHandelChanges.bind(this)
  }
  componentWillMount () {
    if (this.props.activeOperation === 'add') {
      this.setState({
        addOption: true,
        editOption: false,
        showDetails: false,
        loader: false,
        selectedItem: '',
        form:{...formDefault},
        // form:{...formDefault,attributes:{}}
      })
    }
    if (this.props.activeOperation === 'edit') {
      this.setState({
        addOption: false,
        editOption: true,
        showDetails: false,
        loader: false,
        selectedItem: this.props.selectedItem,
        form: { ...this.props.selectedItem }
      })
    }
    if (this.props.activeOperation === 'remove') {
      this.isDeleteRole(this.props.selectedItem)
    }
    if (this.props.activeOperation === 'showDetails') {
      this.preparePrivilagesGroups()
      this.setState({
        addOption: false,
        editOption: false,
        showDetails: true,
        selectedItem: this.props.selectedItem
      })
    }
  }
  componentWillUnmount () {
    // this.props.dispatch(toast.removeAll())
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.activeOperation === 'add') {
      this.setState({
        addOption: true,
        editOption: false,
        showDetails: false,
        loader: false,
        selectedItem: '',
        form: {...formDefault},
        // form: {...formDefault,attributes:{}}
      })
    }
    if (nextProps.activeOperation === 'edit') {
      this.setState({
        addOption: false,
        editOption: true,
        showDetails: false,
        loader: false,
        selectedItem: nextProps.selectedItem,
        form: { ...nextProps.selectedItem }
      })
    }
    if (nextProps.activeOperation === 'remove') {
      this.isDeleteRole(nextProps.selectedItem)
    }
    if (nextProps.activeOperation === 'showDetails') {
      this.setState({
        addOption: false,
        editOption: false,
        showDetails: true,
        selectedItem: nextProps.selectedItem
      })
    }
  }
  preparePrivilagesGroups = () => {
    let test = {},
      result = [],
      perants = {}
      this.props.privileges.map(a => {
      let checked = false
      if (this.props.itemPrivileges.length) {
        let value = this.props.itemPrivileges.find(dec => dec.id === a.id)
        if (value) {
          checked = true
        }
      }
      a['checked'] = checked
      if (a.parentId === 0) {
        a['checkedAll'] = true
        perants = { ...perants, [a.key]: true }
        test[a.id] = { ...a, children: a.children || [] }
        test[a.id].children.push(a)
      } else {
        test[a.parentId] = test[a.parentId] || { data: {}, children: [] }
        test[a.parentId].children.push(a)
      }
    })
    if (test) {
      result = Object.keys(test).map(function (key) {
        return test[key]
      })
      if (result) {
        result.map(item => {
          delete item.children[0].checkedAll
          if (item.checked) {
            let value = item.children.find(child => child.checked === false)
            if (value) {
              item.checkedAll = false
            }
          } else {
            item.checkedAll = false
          }
        })
      }
    }
    this.setState({
      allPrivilagesGroups: result,
      open: perants,
      privilegeSearch: ''
    })
  }

  handlePrivilegeSearch = (e) => {
    const privilegeSearch = e.target.value || ''
    const query = privilegeSearch.trim().toLowerCase()
    const open = { ...this.state.open }

    if (query && Array.isArray(this.state.allPrivilagesGroups)) {
      this.state.allPrivilagesGroups.forEach((group) => {
        if (!group?.key) return
        const parentLabel = (
          this.props.translate(
            group.key === 'poi' ? 'poiH' : group.key
          ) || ''
        ).toLowerCase()
        const parentMatch =
          parentLabel.includes(query) ||
          String(group.key).toLowerCase().includes(query)
        const childMatch = (group.children || []).some((child) => {
          const childKey =
            child.key === 'position' ? 'unitposition' : child.key
          const childLabel = (
            this.props.translate(childKey) || ''
          ).toLowerCase()
          return (
            childLabel.includes(query) ||
            String(child.key || '').toLowerCase().includes(query)
          )
        })
        if (parentMatch || childMatch) {
          open[group.key] = true
        }
      })
    }

    this.setState({ privilegeSearch, open })
  }

  getFilteredPrivilegeGroups = () => {
    const groups = Array.isArray(this.state.allPrivilagesGroups)
      ? this.state.allPrivilagesGroups
      : []
    const query = (this.state.privilegeSearch || '').trim().toLowerCase()
    if (!query) return groups

    // Only hide/show whole groups — never clone/replace children
    // so assign/unassign keeps using original objects
    return groups.filter((group) => {
      if (!group?.key) return false
      const parentLabel = (
        this.props.translate(
          group.key === 'poi' ? 'poiH' : group.key
        ) || ''
      ).toLowerCase()
      if (
        parentLabel.includes(query) ||
        String(group.key).toLowerCase().includes(query)
      ) {
        return true
      }
      return (group.children || []).some((child) => {
        const childKey =
          child.key === 'position' ? 'unitposition' : child.key
        const childLabel = (
          this.props.translate(childKey) || ''
        ).toLowerCase()
        return (
          childLabel.includes(query) ||
          String(child.key || '').toLowerCase().includes(query)
        )
      })
    })
  }

  addSubmit = () => {
    let { form } = this.state
    // form['reportInterval']=form.reportInterval*24*60*60
    // form.attributes['dataHistory']=form.timeInterval*24*60*60
    if (form.description.trim().length > 0) {
      const obj = { ...form }
      fetch('/api/roles/', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...obj
        })
      })
        .then(response => {
          if (response.ok) {
            response.json().then(res => {
              if(res.status ==='success'){
                let role=res.data
                this.setState({
                  addOption: false,
                  isVisableRoleBtn: false,
                  form: ''
                })
                this.props.dispatch(addRole(role))
                if (this.props.onCloseModal) {
                  this.props.onCloseModal()
                }
              
                  toast.success(
                     this.props.translate('roleIsAdded')
                )
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
                
                  toast.error(
                    this.props.translate(err[1])
                )
              }
            })
          } else {
            throw response
          }
        })
        .catch(e => {
          
            toast.error(
              'Something went wrong'
          )
        })
    } else {

        toast.error(
          this.props.translate('descriptionIsEmpty')
      )
    }
  }
  editSubmit = () => {
    let { form,addO } = this.state
    // if(addO){
    //   form['timeInterval']=form.timeInterval*24*60*60
    // }
    
    if (form.description.trim().length > 0) {
      const obj = { ...form }
      // if(addO){
      //   obj['reportInterval']=obj.reportInterval*24*60*60
      // }
      fetch(`/api/roles/${form.id}`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...obj
        })
      })
        .then(response => {
          if (response.ok) {
            response.json().then(res => {
              if(res.status ==='success'){
                this.props.dispatch(updateRole(res.data))
                if (this.props.onCloseModal) {
                  this.props.onCloseModal()
                }
   
                  toast.success(
                    this.props.translate('roleIsUpdated')             
                )
                this.setState({
                  editOption: false,
                  isVisableRoleBtn: false,
                  form: ''
                })
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
              
                  toast.error(
                 this.props.translate(err[1])
                )
              }
            })
          } else {
            throw response
          }
        })
        .catch(e => {
          // if(e && e.text){
          //   e.text().then(err => {
          //   var array = err&&err.split("-")
          //   this.props.dispatch(toast.error({
          //         message: this.props.translate(array[0]),
          //         autoDismiss: 5
          //      }))
          //   })
          // }
          // else{
            toast.error(
           this.props.translate('somthingWentWrongMessage')
            )
          // }
        })
      this.setState({
        isVisableRoleBtn: false
      })
    } else {
    
        toast.error(
         this.props.translate('descriptionIsEmpty')
      )
    }
  }
  isDeleteRole = item => {
    this.setState({
      addOption: false,
      editOption: false,
      showDetails: false,
      selectedItem: item,
      onDeleteConfirmation: true
    })
  }
  deleteRole = () => {
    const { selectedItem } = this.state
    if (selectedItem.id) {
      fetch(`/api/roles/${selectedItem.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...selectedItem
        })
      })
        .then(response => {
            response.json().then(res=>{
              if(res.status === "success"){
                this.props.dispatch(removeRole(selectedItem))
                if (this.props.onCloseModal) {
                  this.props.onCloseModal()
                }
   
                  toast.success(
                     this.props.translate('roleIsDeleted')
                )
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
             
                  toast.error(
                    this.props.translate(err[1])
                )
              }
              else {
                throw response
              }
            })
        })
        .catch(e => {
 
            toast.error(
              'something went wrong'
          )
        })
      this.setState({
        selectedItem: '',
        addOption: false,
        editOption: false,
        attributeChangesMessage: '',
        onDeleteConfirmation: false
      })
    }
  }

  handleChange = name => event => {
    const { target } = event
    if (target.type === 'checkbox') {
      this.setState(
        preState => ({
          ...preState,
          form: {
            ...preState.form,
            [name]: target.checked
          }
        }),
        () => this.checkRequiredFields()
      )
    }else if(name ==='reportInterval') {
      this.setState(
        preState => ({
          ...preState,
          form: {
            ...preState.form,
            [name]: target.value
          },
        }),
        () =>{
          this.setState({addO:true})
          this.checkRequiredFields()}
      )
    }
    else {
      this.setState(
        preState => ({
          ...preState,
          form: {
            ...preState.form,
            [name]: target.value
          }
        }),
        () =>{
          this.checkRequiredFields()}
      )
    }
  }
  checkRequiredFields = () => {
    let { name, description } = this.state.form
    let value = !isEqual(this.state.form, this.state.selectedItem)
    if (name&&name.trim().length > 0 && description && value) {
      this.setState({
        isVisableRoleBtn: true
      })
    } else {
      this.setState({
        isVisableRoleBtn: false
      })
    }
  }
  modalControle = () => {
    this.setState({
      addOption: false,
      editOption: false
    })
    this.props.onCloseModal()
  }
  checkHandelChanges = (event, type, data) => {
    const isChecked = !!event.target.checked
    let checkPivilge = false
    if (isChecked) {
      if (checkPrivileges('roleLinkPrivilege')) checkPivilge = true
    } else {
      if (checkPrivileges('roleUnlinkPrivilege')) checkPivilge = true
    }
    if (!checkPivilge) {
      toast.error(this.props.translate('lackOfPrivileges'))
      return
    }

    if (
      this.props.logInUser.userType !== -1 &&
      this.state.selectedItem.id < 8
    ) {
      toast.error(this.props.translate('ownerAccessDenied'))
      return
    }

    const dataId = Number(data.id)
    const dataParentId = Number(data.parentId)
    // Shallow-clone groups/children so React always gets a new state tree
    const allPrivilages = (this.state.allPrivilagesGroups || []).map(group => ({
      ...group,
      children: (group.children || []).map(child => ({ ...child }))
    }))

    if (type === 'parent') {
      allPrivilages.forEach(prvilg => {
        if (Number(prvilg.id) !== dataId) return
        prvilg.checked = isChecked
        prvilg.checkedAll = isChecked
        ;(prvilg.children || []).forEach(child => {
          child.checked = isChecked
          this.multiPrivilageHandel(child.id, isChecked)
        })
        toast.success(
          this.props.translate(
            isChecked
              ? 'groupsPrivilageAssignedSuccessfully'
              : 'groupsPrivilageRemoved'
          )
        )
      })
      this.setState({
        allPrivilagesGroups: allPrivilages,
        loader: false
      })
      return
    }

    if (type === 'child') {
      allPrivilages.forEach(prvilg => {
        const isTargetGroup =
          dataParentId === 0
            ? Number(prvilg.id) === dataId
            : Number(prvilg.id) === dataParentId
        if (!isTargetGroup) return

        ;(prvilg.children || []).forEach(child => {
          if (Number(child.id) === dataId) {
            child.checked = isChecked
          }
        })
        prvilg.checkedAll = (prvilg.children || []).every(c => !!c.checked)
        if (dataParentId === 0) {
          prvilg.checked = isChecked
        }
      })

      // Update UI immediately, then sync API
      this.setState({
        allPrivilagesGroups: allPrivilages,
        loader: true
      })

      const option = isChecked ? 'POST' : 'DELETE'
      fetch(`/api/permissions`, {
        method: option,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          roleId: this.state.selectedItem.id,
          privilegeId: data.id
        })
      })
        .then(response => response.json())
        .then(res => {
          if (res.status === 'success') {
            this.setState({ loader: false })
            toast.success(
              this.props.translate(
                option === 'POST'
                  ? 'privilageAssignedSuccessfully'
                  : 'privilageRemoved'
              )
            )
          } else if (res?.statusCode === '440') {
            window.location.replace('/login')
          } else if (res.statusCode) {
            const err = res?.message.split(':')
            err[1] = err[1].replace(')', '')
            toast.error(this.props.translate(err[1]))
            this.setState({ loader: false })
          } else {
            throw res
          }
        })
        .catch(() => {
          toast.error(this.props.translate('somthingWentWrongMessage'))
          this.setState({ loader: false })
        })
    }
  }
  multiPrivilageHandel = (id, checked) => {
    let option = 'POST'
    if (id) {
      let obj = {
        roleId: this.state.selectedItem.id,
        privilegeId: id
      }
      if (checked === false) {
        option = 'DELETE'
      }
      fetch(`/api/permissions`, {
        method: `${option}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...obj
        })
      })
        .then(response => {
            response.json().then(res =>{              
            if (res.status === "success") {
              if (option === 'POST') {
                return option
              } else {
                return option
              }
            }
            else if(res?.statusCode === '440'){
              window.location.replace('/login')
            }
            else if(res.statusCode){
              console.log('res =', res?.message)
            }
            // else if(res.statusCode){
            //   var err = res.message.split(':')
            //   err[1] =err[1].replace(')', "")
            //   this.props.dispatch(
            //     toast.error({
            //       message: this.props.translate(err[1]),
            //       autoDismiss: 5,
            //       location: this.props.location
            //     })
            //   )
            // } 
            else {
              throw response
            }
          })
        })
        .catch(e => {
         
            toast.error(
              this.props.translate('somthingWentWrongMessage')
          )
          //window.location.pathname = '/roleManagement'
        })
    }
  }

  handleClick = item => {
    let coll = this.state.open[item]
    this.setState({
      open: { ...this.state.open, [item]: !coll }
    })
  }

  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false
    })
    if (this.props.onCloseModal) {
      this.props.onCloseModal()
    }
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  // }
  render () {
    const groupsForList = this.state.showDetails
      ? this.getFilteredPrivilegeGroups()
      : []

    return (
      <Fragment>
        {this.state.addOption && (
          <AddRoleModal
            translate={this.props.translate}
            formSubmit={this.addSubmit}
            handleChange={this.handleChange}
            form={this.state.form}
            addOption={true}
            modalControle={this.modalControle}
            buttonText={this.props.translate('sharedCreate')}
            isVisableRoleBtn={this.state.isVisableRoleBtn}
          />
        )}
        {this.state.editOption && (
          <AddRoleModal
            translate={this.props.translate}
            formSubmit={this.editSubmit}
            handleChange={this.handleChange}
            form={this.state.form}
            addOption={this.state.addO}
            modalControle={this.modalControle}
            buttonText={this.props.translate('update')}
            isVisableRoleBtn={this.state.isVisableRoleBtn}
          />
        )}
        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            translate={this.props.translate}
            onCancel={this.onCancel}
            onOk={this.deleteRole}
            title={this.props.translate('areYouWantToDelete')}
            children={this.state.selectedItem.name}
          />
        )}
        {this.state.showDetails ? (
          <PrivilegesPanel
            groups={groupsForList}
            open={this.state.open}
            privilegeSearch={this.state.privilegeSearch}
            onSearchChange={this.handlePrivilegeSearch}
            onPrivilegeChange={this.checkHandelChanges}
            onToggleGroup={this.handleClick}
            classes={this.props.classes}
            translate={this.props.translate}
            themecolors={this.props.themecolors || {}}
          />
        ) : null}
      </Fragment>
    )
  }
}

const mapState = state => ({
  privileges: state.privileges,
  logInUser: state.logInUsers,
  themecolors: state.themecolors
})
const mapStateToProps = connect(mapState)
export const RoleModal = mapStateToProps(
  withStyles(styles)(roleModal)
)
